var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('kst-number-with-date',{attrs:{"input-mode":"","catalog":_vm.Catalog,"data":_vm.userData,"autoNumberField":"IsAutoNumber","dateField":"Date","numberField":"ClosingNumber"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }